import React, { useState, useEffect } from 'react'
import {
  ToastContext,
  Container,
  Image,
  TextCaption,
  TextBody,
  BlockingLoader
} from '@pdrj/pmi-iqos-ds-react'
import {
  CommonTranslations,
  PublishedComponent,
  parseTranslations,
  constants,
  cookie,
  JWTDecode,
  EditLink
} from '@pdrj/pmi-iqos-shared-react'
import { AvatarFormPopup } from '@iqosphere-common/components'
import { getInitialPropsMock } from '@iqosphere-common/utils'
import { IqosphereApiManager } from '@iqosphere-common/services'

import ProfileAvatarTranslations from './profile-avatar.json'

const ProfileAvatarComponent = ({ translations, line, avatarList }) => {
  const [openModal, setOpenModal] = useState(false)
  const [userInfo, setUserInfo] = useState({
    avt: {
      code: '',
      accessory: '',
      nickname: '',
      imgAvatarSrc: '',
      imgAccessorySrc: ''
    }
  })
  const [loading, setLoading] = useState(true)

  const api = new IqosphereApiManager(line)
  const popupToast = ToastContext.getContextActions().popupToast

  useEffect(() => {
    loadData()
  }, [])

  const loadData = async () => {
    setLoading(true)
    const profileData = {
      avt: {
        code: '',
        accessory: '',
        nickname: '',
        imgAvatarSrc: '',
        imgAccessorySrc: ''
      }
    }
    try {
      await api.iqosphereProfile.getAvatarProfile()
      const decodedToken = JWTDecode(
        cookie.get(constants.COOKIE_LOYALTY_AVATAR)
      )

      if (decodedToken && decodedToken.avt && decodedToken.avt.code) {
        profileData.avt.code = decodedToken.avt.code
        profileData.avt.accessory = decodedToken.avt.accessory
        const retrievedAvatar =
          avatarList.find(
            avatar => avatar.avatar_code === profileData.avt.code
          ) || {}
        const selectedAccessory =
          retrievedAvatar?.accessories.find(
            acc => acc.accessory_code === profileData.avt.accessory
          ) || null
        profileData.avt.nickname = retrievedAvatar?.nickname
        profileData.avt.imgAvatarSrc = retrievedAvatar?.base_avatar_src
        profileData.avt.imgAccessorySrc = selectedAccessory?.src || null
      } else {
        const defaultAvatar = avatarList.find(avatar => avatar.default) || {}
        profileData.avt.code = defaultAvatar?.avatar_code
        profileData.avt.nickname = defaultAvatar?.nickname
        profileData.avt.imgAvatarSrc = defaultAvatar?.base_avatar_src
      }
      setUserInfo(profileData)
    } catch (err) {
      console.error(err)
      popupToast({
        type: ToastContext.types.error,
        subtitle: translations.tk_updateError
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <Container position={Container.positions.relative}>
      {loading && <BlockingLoader loading />}
      <Container
        display={Container.displays.flex}
        justifyContent={Container.justifyContentValues.end}>
        <EditLink
          text={translations.tk_editButton}
          onClickHandler={() => setOpenModal(true)}
        />
      </Container>

      <Container
        display={Container.displays.flex}
        flexDirection={Container.flexDirections.column}
        alignItems={Container.alignItemsValues.center}
        width="full">
        {!loading && (
          <Image
            src={userInfo.avt.imgAccessorySrc || userInfo.avt.imgAvatarSrc}
            width="40"
            rounded={Image.roundedSizes.full}
            contain
          />
        )}

        <Container pt="4" flexShrink={2} display={Container.displays.flex}>
          <TextCaption size={TextCaption.sizes.l}>
            {translations.tk_nickname}:
          </TextCaption>
          <TextBody size={TextBody.sizes.l} additionalClasses="q-pl-2">
            {userInfo.avt.nickname}
          </TextBody>
        </Container>
      </Container>
      {openModal && (
        <AvatarFormPopup
          isOpen={openModal}
          setOpenModal={setOpenModal}
          avatarList={avatarList}
          onClose={() => setOpenModal(false)}
          userInfo={userInfo}
          loadData={loadData}
          isUpdate
          line={line}
          translations={translations}
        />
      )}
    </Container>
  )
}

const ProfileAvatar = props => {
  return (
    <ToastContext>
      <PublishedComponent
        innerComponent={ProfileAvatarComponent}
        {...ComponentDefaultProps}
        {...props}
      />
    </ToastContext>
  )
}

const ComponentTranslations = {
  ...ProfileAvatarTranslations,
  ...CommonTranslations
}

const defaultTranslations = {
  ...parseTranslations(ComponentTranslations, true)
}

const ComponentDefaultProps = {
  componentName: 'ProfileAvatar',
  translations: defaultTranslations,
  defaultTranslations: defaultTranslations,
  translationsConfig: ComponentTranslations
}

ProfileAvatar.getInitialProps = async req => {
  return PublishedComponent.getGlobalInitialProps({
    context: req && req.query && req.query.context,
    line: !!req?.query?.line,
    componentName: ComponentDefaultProps.componentName,
    defaultTranslations: ComponentDefaultProps.translations,
    translationsConfig: ComponentTranslations,
    getSpecificInitialProps: () => {
      const avatarList =
        req && req.query && req.query.mock === 'true'
          ? getInitialPropsMock('avatarList')
          : (req.body.extra && req.body.extra.avatars) || []
      return { avatarList }
    }
  })
}

export default ProfileAvatar
